<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border row-key="id" :tree-props="{children: 'children'}"
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="菜单名" width="180" align="center"
                             prop="name"></el-table-column>
            <el-table-column show-overflow-tooltip label="编码" align="center"
                             prop="code"></el-table-column>
            <el-table-column show-overflow-tooltip label="排序值" align="center"
                             prop="sort"></el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="remark"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="160" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="menuDialog.visible" :close-on-click-modal="false" width="30%" title="编辑菜单">
      <el-form ref="roleForm" label-position="right" label-width="100px" :model="menuDialog.formData"
               :rules="rules">
        <el-form-item label="菜单名：" prop="name">
          <el-input placeholder="请输入菜单名" v-model="menuDialog.formData.name"
                    clearable/>
        </el-form-item>
        <el-form-item label="编码：" prop="code">
          <el-input placeholder="请输入编码" v-model="menuDialog.formData.code"
                    clearable disabled/>
        </el-form-item>
        <el-form-item label="排序值：" prop="sort">
          <el-input-number style="width: 100%;" :min="0" :step="1" v-model="menuDialog.formData.sort"/>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="menuDialog.formData.remark" clearable/>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="menuDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="updateMenu" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


import {getMenus, updateData} from "@/api/menu";

export default {
  data() {
    return {
      table: {
        data: []
      },
      menuDialog: {
        formData: {
          name: '',
          code: '',
          sort: '',
          remark: ''
        },
        visible: false
      },
      rules: {
        name: [
          {trigger: 'blur', required: true, message: '请输入菜单名'}
        ],
        code: [
          {trigger: 'blur', required: true, message: '请输入编码'}
        ],
        sort: [
          {trigger: 'blur', required: true, message: '请输入排序值'}
        ]
      },
      loading: false,
      tableLoading: false
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    // 搜索框查询
    search() {
      this.tableLoading = true
      getMenus().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 新增修改菜单
    updateMenu() {
      this.loading = true
      this.$refs['roleForm'].validate(async (valid) => {
        if (valid) {
          updateData(this.menuDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.menuDialog.visible = false
              this.search()
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data) {
      this.menuDialog.formData = JSON.parse(JSON.stringify(data))
      this.menuDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.roleForm.clearValidate()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/menu.vue